import React from "react";
import { useNavigate } from "react-router-dom";
import { OutputData } from "@editorjs/editorjs";
import Form from "../../../../common/forms/Form";
import FormInput from "../../../../common/forms/FormInput";
import TagInput from "../../../../common/forms/TagInput";
import FormImageItem from "../../../../common/forms/FormImageItem";
import RichTextArea from "../../../../common/forms/RichTextArea";
import BackBar from "../../../../common/nav/BackBar";
import SaveButton from "../../../../common/nav/SaveButton";
import { ImageSourceSetData } from "../../../../common/classes/ImageSourceSet";
import { getCurrentDateForInputs } from "../../../../utils/GeneralUtils";
import {
  ValType,
  getErrorMessage,
} from "../../../../utils/ValidationFunctions";
import { TermType } from "../../../../utils/useTerm";
import styles from "../EditBase.module.scss";
import { SonicTermData } from "../../../../common/classes/SonicTerm";
import SelectMultipleTerms from "../../../../common/forms/SelectMultipleTerms";
import SonicLink from "../../../../common/routing/SonicLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  title?: string;
  topicType?: string;
  startDate?: number;
  tags?: Array<string> | string;
  mainImage?: File | ImageSourceSetData;
  article?: OutputData;
  topicTypes: [string, string][] | [];

  //MyGame
  games?: Array<SonicTermData>;
  handleGames: (value: Array<SonicTermData>) => void;

  // facilityOptions: [string, string][];
  // facilityId?: string;

  isEdit: boolean;
  error: { required: boolean; imgs: boolean };
  handleInputChange: (value: File | string | undefined, name: string) => void;
  handlePrivate?: () => void;
  handleSave?: () => void;
  handleSubmit?: () => void;
  handlePreview: () => void;
  deleteMainImage: () => void;
  handleSaveArticle: (outputData: OutputData) => void;
  handleChangeArticle: () => void;
};
const EditTopic: React.FC<Props> = ({
  title,
  topicType,
  startDate,
  tags,
  mainImage,
  article,
  topicTypes,
  games,
  handleGames,
  // facilityOptions,
  // facilityId,
  isEdit,
  error,
  handleInputChange,
  handlePrivate,
  handleSave,
  handleSubmit,
  handlePreview,
  deleteMainImage,
  handleSaveArticle,
  handleChangeArticle,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <BackBar
        title={isEdit ? "トピックス編集" : "トピックス作成"}
        editable={true}
        handleClose={() => navigate(-1)}
        previewHandler={handlePreview}
      />
      <Form handler={() => {}} className={styles["p-edit__wrapper"]}>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="text"
            label="トピックス名"
            label_class={`${styles["p-edit__form-title"]} ${styles["required-mark"]}`}
            name="sonic_name"
            style_class={styles["p-edit__form-input"]}
            handler={handleInputChange}
            val_type={ValType.NotNull}
            initial_value={title}
          />
        </div>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="select"
            label="トピックスカテゴリ"
            name="sonic_topic_type"
            holder_class={styles["holder"]}
            select_class={styles["select"]}
            label_class={`${styles["p-edit__form-title"]} ${styles["required-mark"]}`}
            style_class={styles["p-edit__form-input"]}
            handler={handleInputChange}
            val_type={ValType.NotNull}
            options={topicTypes}
            placeholder="カテゴリを選択"
            initial_value={topicType}
            merit_text="カテゴリ検索でヒットします。"
          />
        </div>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="date"
            label="掲載開始日"
            name="sonic_start_date"
            val_type={ValType.NotNull}
            handler={handleInputChange}
            label_class={`${styles["p-edit__form-title"]} ${styles["required-mark"]}`}
            style_class={styles["p-edit__form-input"]}
            input_wrap_class={styles["date-wrap"]}
            min_date={getCurrentDateForInputs()}
            initial_value={startDate}
            merit_text="審査を通過後、掲載開始日になると公開されます。"
          />
        </div>
        <div className={styles["p-edit__form"]}>
          <label
            className={`${styles["p-edit__form-title"]} ${styles["required-mark"]}`}
          >
            メイン画像
            <div className={styles["p-edit__title-desc"]}>
              画像を設定することであなたのトピックスがユーザーの目に留まりやすくなります。
            </div>
          </label>
          {mainImage ? (
            <FormImageItem
              img={
                mainImage instanceof File ? mainImage : mainImage.thumbnail?.url
              }
              i={0}
              deleteImg={() => {
                deleteMainImage();
              }}
            />
          ) : null}
          {mainImage == undefined ? (
            <>
              <button type="button" className={styles["p-edit__form-addImg"]}>
                <FormInput
                  type="file"
                  label="画像を追加"
                  id="imgs"
                  name="sonic_imgs"
                  handler={handleInputChange}
                  val_type={ValType.File}
                />
              </button>
            </>
          ) : null}
          <div className={styles["p-edit__form-supplement"]}>
            <p className={styles["p-edit__form-supplement-text"]}>
              ※記事のサムネイルになります
            </p>
            <p className={styles["p-edit__form-supplement-limit"]}>
              アップロード上限：10MB以内
            </p>
          </div>
        </div>
        <div className={styles["p-edit__editor"]}>
          <label
            className={`${styles["p-edit__form-title"]} ${styles["required-mark"]}`}
          >
            本文
          </label>
          <RichTextArea
            richTextData={article}
            setArticle={handleSaveArticle}
            changeArticle={handleChangeArticle}
          />
          <div className={styles["p-edit__form-supplement"]}>
            <p className={styles["p-edit__form-supplement-text"]}>
              {
                "+ボタンで追加できます。\n⋮⋮ボタンで位置の移動や削除、その他変更ができます。"
              }
            </p>
          </div>
        </div>
        <div className={styles["p-edit__form"]}>
          <div className={styles["p-edit__form-title"]}>ゲーム</div>
          <p>ゲームから検索されやすくなります</p>
          <div className={styles["p-edit__form__current-mygame"]}>
            {games && games.length > 0 ? (
              <div className={styles["p-edit__form__current-mygame-list"]}>
                <p>設定済み</p>
                <ul>
                  {games.map((game, i) => (
                    <li
                      key={i}
                      className={
                        styles["p-edit__form__current-mygame-list-item"]
                      }
                    >
                      {game.name}
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div
                className={styles["p-edit__form__current-mygame-list--none"]}
              >
                {"まだゲームが設定されていないようです。"}
              </div>
            )}
          </div>
          <SelectMultipleTerms
            termType={TermType.Games}
            termName="ゲーム"
            buttonText="ゲームを選ぶ"
            terms={games ? games : []}
            handleTerms={handleGames}
          />
          <div className={styles["p-edit__help"]}>
            <SonicLink to="/contact" newTab={true}>
              {"ご希望のゲームがない方はこちら"}
            </SonicLink>
          </div>
        </div>
        <div className={styles["p-edit__form"]}>
          <TagInput
            label="タグ"
            label_class={styles["p-edit__form-title"]}
            name="sonic_tags"
            id="tags"
            input_class={styles["p-edit__form-input"]}
            tag_class={styles["p-edit__form-input-tag"]}
            handler={handleInputChange}
            value={tags}
            merit_text="タグで絞り込みが可能になります。"
          />
          <div className={styles["p-edit__form-supplement"]}>
            <p className={styles["p-edit__form-supplement-text"]}>
              {`各タグの入力後は必ずEnterキーを押してください。\nスマートフォンをご利用の方はキーボード右下の完了ボタンを押してください。\n`}
              確定後は
              <span
                className={`${styles["p-edit__form-input-tag"]} ${styles["preview"]}`}
              >
                {`#タグ名`}
                <span>
                  <FontAwesomeIcon icon={["fas", "times"]} />
                </span>
              </span>
              の表示になります。
              {`\n※Spaceキーは使用できません`}
            </p>
          </div>
        </div>
        {/* <div className={styles["p-edit__form"]}>
          <FormInput
            type="select"
            label="該当施設"
            name="sonic_facility"
            holder_class={styles["holder"]}
            select_class={styles["select"]}
            label_class={styles["p-edit__form-title"]}
            style_class={styles["p-edit__form-input"]}
            handler={handleInputChange}
            options={facilityOptions}
            initial_value={facilityId}
          />
        </div> */}
      </Form>
      {error.required ? (
        <div className={styles["p-edit__error"]}>
          必須項目が未入力、または入力内容に誤りがあります
        </div>
      ) : null}
      {error.imgs ? (
        <div className={styles["p-edit__error"]}>
          {getErrorMessage(ValType.FileTotalSize)}
        </div>
      ) : null}
      {handlePrivate ? (
        <SaveButton
          title="非公開で保存"
          onClick={handlePrivate}
          type={"neon-blue"}
        />
      ) : null}
      {handleSave ? <SaveButton title="保存" onClick={handleSave} /> : null}

      {handleSubmit ? (
        <SaveButton title="公開申請" onClick={handleSubmit} />
      ) : null}
      <SaveButton title="プレビュー" onClick={handlePreview} />
    </>
  );
};

export default EditTopic;
